import scrollTopButton from '../components/scrollTopButton';

/**
 * Page scroll handler for the entire project
 * 
 */

function scrollTop() {
  let scrollTop = window.scrollY || document.documentElement.scrollTop;
  const buttonUpElement = document.querySelector('.button-up');

  const handleButton = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleScroll = () => {
    scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (buttonUpElement) {
      scrollTopButton(buttonUpElement, scrollTop);
    }
  };

  window.addEventListener('scroll', handleScroll);

  if (buttonUpElement) {
    buttonUpElement.addEventListener('click', handleButton);
    
    scrollTopButton(buttonUpElement, scrollTop);
  }
}

export default scrollTop;